export default function VisualProgressBar({
  label,
  value = 0,
  max = 100,
  hint = '',
  accent = 'lime',
}) {
  const pct = max > 0 ? Math.min(100, Math.round((Number(value) / Number(max)) * 100)) : 0;
  const tone = accent === 'amber' ? 'ef-progress--amber' : accent === 'emerald' ? 'ef-progress--emerald' : 'ef-progress--lime';

  return (
    <div className={`ef-progress ${tone}`}>
      <div className="ef-progress__head">
        <span className="ef-progress__label">{label}</span>
        <span className="ef-progress__value">{pct}%</span>
      </div>
      <div className="ef-progress__track" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
        <div className="ef-progress__fill" style={{ width: `${pct}%` }} />
      </div>
      {hint ? <p className="ef-progress__hint">{hint}</p> : null}
    </div>
  );
}
